import { useEffect } from 'react'
import SEO from '../components/SEO'
import StageLayout from '../components/StageLayout'
import Footer from '../components/Footer'

const WHATIS_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: 'What is TokenDance?',
  description:
    'TokenDance is a forward-deployed engineering and LLM infrastructure company that helps teams ship production AI systems.',
  author: { '@type': 'Organization', name: 'TokenDance' },
  publisher: { '@id': 'https://tokendance.net/#organization' },
  mainEntityOfPage: 'https://tokendance.net/what-is-TokenDance',
  datePublished: '2026-04-24',
  dateModified: '2026-08-04',
  about: { '@id': 'https://tokendance.net/fde#service' },
}

export default function WhatIs() {
  useEffect(() => {
    document.body.classList.add('v2-plain-page')
    return () => document.body.classList.remove('v2-plain-page')
  }, [])

  return (
    <>
      <SEO
        title="What is TokenDance? — FDE and LLM infrastructure"
        description="TokenDance is a forward-deployed engineering and LLM infrastructure company for teams shipping production AI systems."
        path="/what-is-TokenDance"
        jsonLd={WHATIS_JSONLD}
      />
      <StageLayout active="why" plain showBottomNav={false}>
        <div className="v2-center v2-why-block">
          <h1 className="v2-why-word">What is TokenDance?</h1>

          <div className="v2-why-sections">
            <section className="v2-why-section">
              <div className="v2-why-label">
                <span className="v2-why-n">01</span>
                <span>In one sentence</span>
              </div>
              <p className="v2-why-body">
                TokenDance is a forward-deployed engineering and LLM infrastructure
                company for teams shipping production AI systems.
              </p>
            </section>

            <section className="v2-why-section">
              <div className="v2-why-label">
                <span className="v2-why-n">02</span>
                <span>What it actually does</span>
              </div>
              <p className="v2-why-body">
                We embed senior builders with customer teams, scope the workflow, build
                the first production path, and provide the LLM layer around it: model
                routing, structured outputs, evals, retries, logs, usage controls,
                GPU inference paths, and runbooks.
              </p>
            </section>

            <section className="v2-why-section">
              <div className="v2-why-label">
                <span className="v2-why-n">03</span>
                <span>Who it's for</span>
              </div>
              <p className="v2-why-body">
                Teams with real workflows, proprietary data, or model-powered products
                that need to survive production: SaaS companies, enterprise operations,
                support teams, research teams, security teams, and internal platform groups.
              </p>
            </section>

            <section className="v2-why-section">
              <div className="v2-why-label">
                <span className="v2-why-n">04</span>
                <span>How it's different</span>
              </div>
              <p className="v2-why-body">
                Most AI consultancies stop at strategy, and most infrastructure providers
                stop at APIs. TokenDance does both: we build inside the workflow and
                bring the model infrastructure, eval loop, and operating system needed
                after launch.{' '}
                <a className="v2-phase-cta" href="/#how">
                  See how we work
                  <span className="v2-phase-cta-arrow" aria-hidden="true">&rarr;</span>
                </a>
              </p>
            </section>

          </div>
        </div>
      </StageLayout>
      <Footer />
    </>
  )
}
